(function () {
	let initialized = false;
	
	const interestLetterModal = () => {
		if (initialized) return;
		
		const toggleButton = document.querySelector(".steps_content_button");
		const modal = document.querySelector(".interest-letter-modal");
		
		if (!toggleButton || !modal) return;
		
		toggleButton.addEventListener("click", function (e) {
			e.preventDefault();
			e.stopPropagation();
			modal.classList.add("active");
			document.body.classList.add("overflow-hidden");
		});
		
		const modalOverlay = modal.querySelector(".interest-letter-modal__overlay");
		if (modalOverlay) {
			modalOverlay.addEventListener("click", function () {
				modal.classList.remove("active");
				document.body.classList.remove("overflow-hidden");
			});
		}
		
		const modalClose = modal.querySelector(".close_modal_element");
		if (modalClose) {
			modalClose.addEventListener("click", function (e) {
				e.preventDefault();
				e.stopPropagation();
				modal.classList.remove("active");
				document.body.classList.remove("overflow-hidden");
			});
		}
		
		document.addEventListener("keyup", function (e) {
			if (e.key === "Escape") {
				if (modal && modal.classList.contains("active")) {
					modal.classList.remove("active");
					document.body.classList.remove("overflow-hidden");
				}
			}
		});
		
		initialized = true;
	};
	
	document.addEventListener("DOMContentLoaded", function () {
		interestLetterModal();
	});
	
	document.addEventListener("shopify:section:load", function () {
		initialized = false;
		interestLetterModal();
	});
})();
